import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import '@inera/ids-core/components/mobile/menu/register';
import { CommonModule } from '@angular/common';
const _c0 = ["*"];
class IDMobileMenuComponent {
  constructor() {}
  type = undefined;
  variation = '1';
  static ɵfac = function IDMobileMenuComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDMobileMenuComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDMobileMenuComponent,
    selectors: [["id-mobile-menu"]],
    inputs: {
      type: "type",
      variation: "variation"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 2,
    vars: 2,
    consts: [[3, "type", "variation"]],
    template: function IDMobileMenuComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "ids-mobile-menu", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("type", ctx.type)("variation", ctx.variation);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDMobileMenuComponent, [{
    type: Component,
    args: [{
      selector: 'id-mobile-menu',
      template: "<ids-mobile-menu \r\n  [type]=\"type\"\r\n  [variation]=\"variation\">\r\n  <ng-content></ng-content>\r\n</ids-mobile-menu>"
    }]
  }], () => [], {
    type: [{
      type: Input
    }],
    variation: [{
      type: Input
    }]
  });
})();
class IDMobileMenuItemComponent {
  headline;
  expanded;
  secondary;
  active;
  onDidToggleExpansion = new EventEmitter();
  static ɵfac = function IDMobileMenuItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDMobileMenuItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDMobileMenuItemComponent,
    selectors: [["id-mobile-menu-item"]],
    inputs: {
      headline: "headline",
      expanded: "expanded",
      secondary: "secondary",
      active: "active"
    },
    outputs: {
      onDidToggleExpansion: "onDidToggleExpansion"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 2,
    vars: 4,
    consts: [[3, "didToggleExpansion", "headline", "expanded", "secondary", "active"]],
    template: function IDMobileMenuItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "ids-mobile-menu-item", 0);
        i0.ɵɵlistener("didToggleExpansion", function IDMobileMenuItemComponent_Template_ids_mobile_menu_item_didToggleExpansion_0_listener() {
          return ctx.onDidToggleExpansion.emit(true);
        });
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("headline", ctx.headline)("expanded", ctx.expanded)("secondary", ctx.secondary)("active", ctx.active);
      }
    },
    styles: ["[_nghost-%COMP%]{display:contents}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDMobileMenuItemComponent, [{
    type: Component,
    args: [{
      selector: "id-mobile-menu-item",
      template: "<ids-mobile-menu-item \r\n      [headline]=\"headline\"\r\n      [expanded]=\"expanded\"\r\n      [secondary]=\"secondary\"\r\n      [active]=\"active\"\r\n      (didToggleExpansion)=\"onDidToggleExpansion.emit(true)\">\r\n      <ng-content></ng-content>\r\n</ids-mobile-menu-item>",
      styles: [":host{display:contents}\n"]
    }]
  }], null, {
    headline: [{
      type: Input
    }],
    expanded: [{
      type: Input
    }],
    secondary: [{
      type: Input
    }],
    active: [{
      type: Input
    }],
    onDidToggleExpansion: [{
      type: Output
    }]
  });
})();
class IDMobileMenuAvatarComponent {
  type = '';
  username = '';
  maxwidth = '';
  unit = '';
  static ɵfac = function IDMobileMenuAvatarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDMobileMenuAvatarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDMobileMenuAvatarComponent,
    selectors: [["id-mobile-menu-avatar"]],
    inputs: {
      type: "type",
      username: "username",
      maxwidth: "maxwidth",
      unit: "unit"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 2,
    vars: 4,
    consts: [[3, "username", "maxwidth", "unit"]],
    template: function IDMobileMenuAvatarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "ids-mobile-menu-avatar", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("username", ctx.username)("maxwidth", ctx.maxwidth)("unit", ctx.unit);
        i0.ɵɵattribute("type", ctx.type);
      }
    },
    styles: ["[_nghost-%COMP%]{display:contents}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDMobileMenuAvatarComponent, [{
    type: Component,
    args: [{
      selector: 'id-mobile-menu-avatar',
      template: "<ids-mobile-menu-avatar \r\n  [attr.type]=\"type\"\r\n  [username]=\"username\"\r\n  [maxwidth]=\"maxwidth\"\r\n  [unit]=\"unit\">\r\n  <ng-content></ng-content>\r\n</ids-mobile-menu-avatar>",
      styles: [":host{display:contents}\n"]
    }]
  }], null, {
    type: [{
      type: Input
    }],
    username: [{
      type: Input
    }],
    maxwidth: [{
      type: Input
    }],
    unit: [{
      type: Input
    }]
  });
})();
class IDMobileMenuModule {
  static ɵfac = function IDMobileMenuModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDMobileMenuModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: IDMobileMenuModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDMobileMenuModule, [{
    type: NgModule,
    args: [{
      declarations: [IDMobileMenuComponent, IDMobileMenuItemComponent, IDMobileMenuAvatarComponent],
      exports: [IDMobileMenuComponent, IDMobileMenuItemComponent, IDMobileMenuAvatarComponent],
      imports: [CommonModule],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IDMobileMenuAvatarComponent, IDMobileMenuComponent, IDMobileMenuItemComponent, IDMobileMenuModule };
